"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datadogReporter = void 0;
var sli_metrics_client_1 = require("@cvent/sli-metrics-client");
/**
 * DataDog reporter. Sends metrics to data dog as custom actions. Overrides reporter from metrics' package
 * to check if the event should be tracked based on the running environment
 *
 * @param id
 * @param data
 * @returns
 */
var datadogReporter = function (id, data, options, callback) {
    // Apply any specific logic here before calling the datadogReporter from metrics-client
    (0, sli_metrics_client_1.dataDogLogger)(id, data, options, callback);
};
exports.datadogReporter = datadogReporter;
